module.exports = __webpack_public_path__ + "static/media/ico-floating-home-active.9e5d2510.svg";